import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from '../../../../../Button';
import { setRegistrationCurrentStep } from '../../../../../../store/actions/registration';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  onSetRegistrationCurrentStep: PropTypes.func.isRequired,
};

export const StepThree = props => {
  const {
    onSetRegistrationCurrentStep,
    history: { push },
  } = props;

  const handleClick = () => {
    onSetRegistrationCurrentStep(0);
    push('/');
  };

  return (
    <Button variant="contained" color="primary" onClick={handleClick}>
      Done
    </Button>
  );
};

StepThree.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  onSetRegistrationCurrentStep: step =>
    dispatch(setRegistrationCurrentStep(step)),
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps,
  )(StepThree),
);
